/** @format */

/**
 * Colori con significato fisso, comuni a Turni e Presenze (Fase 5).
 * Il colore accompagna sempre un testo o un'icona: da solo non distingue gli stati.
 * I giustificativi usano il colore del loro tipo, schiarito con tinta().
 */
export const C = {
  testo: "#1E2333",
  testoSecondario: "#5A6174",
  linea: "#E2E4EC",
  lineaLeggera: "#EEF0F4",
  fondo: "#F2F3F7",
  fondoGruppo: "#F5F6FA",
  fondoTotali: "#FAFAFC",
  oggi: "#F7F8FD",
  daSvolgere: { fondo: "#EEF0F9", bordo: "#D4D8EE", testo: "#2B3570", hover: "#8F98CC" },
  inCorso: { fondo: "#E6F4EE", bordo: "#B5DCC8", testo: "#155B42", punto: "#1F8A5F" },
  timbrato: { fondo: "#F4F5F8", bordo: "#E3E5EC", testo: "#41475E" },
  anomalia: { fondo: "#FDECEF", bordo: "#EDB0BE", testo: "#9E1F3A" },
  avviso: { fondo: "#FFF3DB", bordo: "#E8A92E", testo: "#8A5300", segno: "#F0B33A" },
  riposo: { fondo: "#F1F2F5", testo: "#666C80" },
  festa: { fondo: "#FBEDF0", testo: "#8E2943" },
  inLinea: "#1F7A55",
  sotto: "#3D4A8F",
  barra: { traccia: "#E6E8F0", inLinea: "#2E8A63", sotto: "#7A86C2", oltre: "#E39B16" },
};

/**
 * Linea oraria delle Presenze: stessi significati di C, con i toni più pieni che servono a
 * blocchi piccoli su una riga (bozza approvata, tavola "Stati").
 */
export const L = {
  turno: { fondo: "#F4F5FB", bordo: "#AEB6DD", testo: "#4A5170" },
  nonTimbrato: { fondo: "#FDF2F4", bordo: "#D9738C", testo: "#9E1F3A" },
  coperto: { fondo: "#F6F7F9", bordo: "#D3D6E0", testo: "#5A6174" },
  aperta: { fondo: "#D3EEE1", bordo: "#78C29D", testo: "#155B42", punto: "#1F8A5F" },
  chiusa: { fondo: "#E4E7EF", bordo: "#BFC4D3", testo: "#2E3346" },
  anomalia: { fondo: "#FBE1E7", bordo: "#D9738C", testo: "#9E1F3A" },
  avviso: { fondo: "#FDEBC8", bordo: "#E8A92E", testo: "#6E4300" },
  // straordinario: il #6A98B9 della piattaforma precedente, come bordo, con fondo e testo nella stessa tinta
  straordinario: { fondo: "#C8DCEB", bordo: "#6A98B9", testo: "#1F4A68" },
  inAttesa: { fondo: "#FBF4CF", bordo: "#D7C64C", testo: "#5C5000" },
  riposo: { fondo: "#F1F2F5", bordo: "#E3E5EC", testo: "#666C80" },
  festa: { fondo: "#FBEDF0", bordo: "#EBC3CD", testo: "#8E2943" },
  adesso: "#1E2333",
};
